var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3341 22.3487L21.1841 15.2821C21.0292 15.1258 20.8449 15.0019 20.6418 14.9172C20.4387 14.8326 20.2208 14.7891 20.0008 14.7891C19.7808 14.7891 19.5629 14.8326 19.3598 14.9172C19.1567 15.0019 18.9724 15.1258 18.8175 15.2821L11.7508 22.3487C11.5946 22.5037 11.4706 22.688 11.386 22.8911C11.3014 23.0942 11.2578 23.312 11.2578 23.5321C11.2578 23.7521 11.3014 23.9699 11.386 24.173C11.4706 24.3761 11.5946 24.5605 11.7508 24.7154C12.0631 25.0258 12.4855 25.2 12.9258 25.2C13.3661 25.2 13.7885 25.0258 14.1008 24.7154L20.0008 18.8154L25.9008 24.7154C26.2112 25.0233 26.6302 25.1969 27.0675 25.1987C27.2868 25.2 27.5043 25.158 27.7073 25.075C27.9104 24.9921 28.0951 24.8699 28.2508 24.7154C28.4126 24.566 28.5432 24.3861 28.635 24.186C28.7269 23.9858 28.7782 23.7695 28.7859 23.5494C28.7937 23.3294 28.7577 23.11 28.6802 22.9039C28.6026 22.6978 28.485 22.5091 28.3341 22.3487Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperArrow);
export default __webpack_public_path__ + "static/media/upper-arrow.ef2d1cff5679fda52e8208bad1070c84.svg";
export { ForwardRef as ReactComponent };